/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

export class Enums_Config {
    public static toString<T>(names: Map<T, string>, value: T) {
        if (names.has(value)) return names.get(value)!;
        else return 'UNDEFINED';
    }

    public static toStringArray<T>(names: Map<T, string>, values: T[]) {
        return values.map(v => this.toString(names, v));
    }

    public static fromString<T>(names: Map<T, string>, value: string): T | undefined {
        const e = Array.from(names).find(([k, v]) => v == value);

        return e ? e[0] : undefined;
    }

    public static VideoInputSourceType = new Map<number, string>([
        [0, 'Input1 HDMI'],
        [1, 'Input2 Display Port'],
    ]);

    public static AudioInputSourceType = new Map<number, string>([
        [0, 'None'],
        [1, 'HDMi Input 1'],
        [2, 'HDMi Input 2'],
    ]);

    public static TestPatternType = new Map<number, string>([
        [0, 'Cycle RGB'],
        [1, 'White'],
        [2, 'Black'],
        [3, 'Red'],
        [4, 'Green'],
        [5, 'Blue'],
        [6, 'LCD Rejuve'],
        [7, 'LCD Rejuve LDIM Off'],
        [16, 'Disable Video'],
    ]);

    public static MemsSensorType = new Map<number, string>([
        [0, 'None'],
        [1, '240 Board'],
        [2, 'EEPROM'],
    ]);

    public static ScreenSizeType = new Map<number, string>([
        [0, '55 Inch'],
        [1, '32 Inch'],
    ]);

    public static TestModeType = new Map<number, string>([
        [0, 'None'],
        [1, 'Water Test'],
        [2, 'SureVu Test'],
        [3, 'Burn In Test'],
        [4, 'Clean Room Test'],
        [5, 'Color Test'],
        [6, 'Gamma Test'],
        [7, 'Level Test'],
        [8, 'Pressure Test'],
        [9, 'Pressure Pretest'],
    ]);

    public static FanBankType = new Map<number, string>([
        [0, 'None'],
        [1, 'Open Loop'],
        [2, 'Heat Exchange'],
        [3, 'Closed Loop'],
    ]);

    public static InfiniteTouchAutoCaptureModeType = new Map<number, string>([
        [0, 'None'],
        [1, 'Touchstorm'],
        [2, 'Water'],
        [3, 'Railed'],
        [3, 'NoisyFreq'],
    ]);

    public static FrameCaptureOrientationType = new Map<number, string>([
        [0, 'Normal'],
        [1, 'Rotate 90'],
        [2, 'Rotate 180'],
        [3, 'Rotate 270'],
    ]);

    public static LuminanceModeType = new Map<number, string>([
        [0, 'Fixed'],
        [1, 'Dynamic'],
    ]);

    public static DaylightAdjustmentModeType = new Map<number, string>([
        [0, 'Eco'],
        [1, 'Vivid'],
    ]);

    public static AmbientLightSensorType = new Map<number, string>([
        [0, 'None'],
        [1, 'Internal'],
        [2, 'External'],
        [3, 'Solar Panel'],
    ]);

    public static DoorWatchdogControlType = new Map<number, string>([
        [0, 'Video On Door Open'],
        [1, 'Video Off Door Open'],
        [2, 'Video Off Until Reset'],
    ]);

    public static GammaVariantType = new Map<number, string>([
        [0, 'Normal'],
        [1, 'Calibrated'],
    ]);

    public static TouchControlType = new Map<number, string>([
        [0, 'None'],
        [1, 'Primary'],
        [2, 'Secondary'],
        [3, 'Both Sides'],
    ]);

    public static MonitorType = new Map<number, string>([
        [0, 'None'],
        [1, 'Monitor Only'],
        [2, 'Monitor Reboot'],
        [3, 'Monitor Blank Display'],
        [4, 'Monitor Reboot Me'],
    ]);

    public static Connector12VType = new Map<number, string>([
        [0, 'None'],
        [8, 'J8'],
        [10, 'J10'],
        [11, 'J11'],
        [12, 'J12'],
        [14, 'J14'],
        [19, 'J19'],
        [23, 'J23'],
        [24, 'J24'],
        [25, 'J25'],
        [27, 'J27'],
        [28, 'J28'],
        [29, 'J29'],
        [32, 'J32'],
        [33, 'J33'],
        [41, 'J41'],
        [48, 'J48'],
        [49, 'J49'],
        [50, 'J50'],
        [52, 'J52'],
        [53, 'J53'],
    ]);

    public static AuxDeviceType = new Map<number, string>([
        [0, 'None'],
        [1, 'Modem'],
        [2, 'Router/Gateway'],
        [3, 'Player 1'],
        [4, 'Pleyer 2'],
        [5, 'Video Server'],
        [6, 'Access Point'],
        [7, 'Aux Light 1'],
        [8, 'TouchScreen 1'],
        [9, 'TouchScreen 2'],
        [10, 'Bike Charger'],
        [11, 'Aux Computer 1'],
        [12, 'Aux Computer 2'],
        [13, 'M2M Modem'],
        [14, 'Ethernet Switch'],
        [15, 'Aux Device 1'],
    ]);

    public static LocalDimModeType = new Map<number, string>([
        [0, 'Enabled'],
        [1, 'Disabled'],
        [2, 'Pixel Mod Off'],
    ]);

    public static LocalDimPowerSaveLevelType = new Map<number, string>([
        [0, 'Aggressive'],
        [1, 'Moderate'],
        [2, 'Conservative'],
    ]);

    public static OsdDoorType = new Map<number, string>([
        [0, 'Clear'],
        [1, 'Magnet'],
        [2, 'Left Latch'],
        [3, 'Right Latch'],
        [4, 'Multiple Latches'],
    ]);

    public static OsdOrientationType = new Map<number, string>([
        [0, 'Landscape'],
        [1, 'Portrait'],
    ]);

    public static RebootPlayerOnStalledVideoType = new Map<number, string>([
        [0, 'Disabled'],
        [1, 'Reboot On Stalled Black'],
        [2, 'Reboot On Stalled Non-Black'],
        [3, 'Reboot On Any Stalled'],
    ]);
    public static DewpointCalculationTempSource = new Map<number, string>([
        [0, 'Fpga Die'],
        [1, 'Processor Board'],
        [2, 'Ambient Inlet'],
        [3, 'Local Ambient'],
        [4, 'Humidity Temp Sensor'],
        [5, 'Closed Loop Temp'],
        [6, 'Backlight 1 Max Temp'],
        [7, 'Backlight 2 Max Temp'],
        [8, 'Average Power Supply Temp'],
    ]);
}
